export default __webpack_public_path__ + "static/media/metro-warning-yellow.de7b052f.svg";